import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  DETAIL_CATEGORY_SALE_REPORT,
} from "../../../Constants/Config";

// PHP-backed twin of detailCategorySaleSlice, read by the "Category Sales
// (Detailed - Old)" screen behind ?source=old - the default screen reads the
// fact-table slice. This stays on the PHP route (BASE_URL +
// vendor_report_api/detailed_category_sale). Nothing else differs, so a
// mismatch between the two screens is a data difference, not a UI one.
const initialState = {
  loading: false,
  detailCategorySaleData: [],
  successMessage: "",
  status: false,
  error: "",
};
let cancelTokenSource;

export const fetchdetailCategorySaleDataOld = createAsyncThunk(
  "detailCategorySaleOld/fetchdetailCategorySaleDataOld",
  async (data, { rejectWithValue }) => {
    const { token, ...newData } = data;

    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();
    try {
      const response = await axios.post(
        BASE_URL + DETAIL_CATEGORY_SALE_REPORT,
        newData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      if (response.data.status === true) {
        const categoryList = Object.keys(response.data.report_data);
        const reportData = response.data.report_data;
        const status = response.data.status;
        return { categoryList, reportData, status };
      } else if (
        response.data.status === false &&
        response.data.message === "No data found"
      ) {
        // If 'report_data' is null, return an empty array and object
        return { categoryList: [], reportData: {}, status: false };
      } else {
        // Handle other error scenarios here if needed
        throw new Error(response.data.message);
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const detailCategorySaleOldSlice = createSlice({
  name: "detailCategorySaleOld",
  initialState,
  reducers: {
    updateStateOfDetailCategoryOld: (state) => {
      state.detailCategorySaleData = [];
    },
    updateStateOfDetailCategoryStatusOld: (state) => {
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchdetailCategorySaleDataOld.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchdetailCategorySaleDataOld.fulfilled,
      (state, action) => {
        state.loading = false;
        state.detailCategorySaleData = action.payload.reportData;
        state.categoryList = action.payload.categoryList;
        state.status = action.payload.status;
        state.error = "";
      }
    );
    builder.addCase(
      fetchdetailCategorySaleDataOld.rejected,
      (state, action) => {
        state.loading = false;
        state.detailCategorySaleData = {};
        state.error = action.error.message;
      }
    );
  },
});

export const {
  updateStateOfDetailCategoryOld,
  updateStateOfDetailCategoryStatusOld,
} = detailCategorySaleOldSlice.actions;
export default detailCategorySaleOldSlice.reducer;
